var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"homewrap"},[_c('section',{staticClass:"home-content"},[_c('div',{staticClass:"topbox"},_vm._l((_vm.userModules),function(item){return _c('moduleBox',{key:item.id,attrs:{"module-name":item.moduleName},on:{"click":function($event){return _vm.clickHanble(item)}}})}),1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }